import { STEPS } from '@perpay-web/fintech/constants/steps/withdrawalSteps';
import { withReduxStepsReducer } from '@perpay-web/hooks/useReduxSteps';

export default withReduxStepsReducer(STEPS);
